import { render, staticRenderFns } from "./FreelancersShow.vue?vue&type=template&id=199ad834&scoped=true"
import script from "./FreelancersShow.vue?vue&type=script&lang=js"
export * from "./FreelancersShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199ad834",
  null
  
)

export default component.exports